import { Component, inject, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HpvConsentComponent } from 'src/app/screens/add-recipient/components/hpv-vaccination/hpv-consent/hpv-consent.component';

@Component({
  selector: 'app-vaccine-consent',
  templateUrl: './vaccine-consent.component.html',
  styleUrls: ['./vaccine-consent.component.scss'],
})
export class VaccineConsentComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() showHardCopyTxt: boolean = false;
  destroy$ = new Subject();
  readonly _bottomSheet = inject(MatBottomSheet);
  isConsentAgreed: boolean = false;

  constructor() {}

  ngOnInit() {
    this.isConsentAgreed = false;
    this.parentForm.get('vaccine_consent').setValidators([Validators.required]);
    this.parentForm.get('vaccine_consent').updateValueAndValidity();
  }

  openBottomSheet() {
    const bottomSheetRef = this._bottomSheet.open(HpvConsentComponent, {
      disableClose: true,
    });
    bottomSheetRef.afterDismissed().subscribe((res) => {
      this.isConsentAgreed = res ?? false;
      // this.parentForm
      //   .get('vaccine_consent')
      //   .setValue(res ?? false, { emitEvent: false });
      if (res) {
        this.parentForm.get('vaccine_consent').setValue(res);
      }
      this.parentForm.get('vaccine_consent').updateValueAndValidity();
      if (!this.isConsentAgreed) {
        this.parentForm
          .get('vaccine_consent')
          .setValidators([Validators.required]);
        this.parentForm.get('vaccine_consent').updateValueAndValidity();
      }
    });
  }

  onCheckConsent(event) {
    if (
      (event.detail.checked && !this.isConsentAgreed) ||
      (!event.detail.checked && this.isConsentAgreed)
    ) {
      this.isConsentAgreed = false;
      this.parentForm.get('vaccine_consent').setValue(null);
      this.parentForm.get('vaccine_consent').updateValueAndValidity();
      this.openBottomSheet();
      event.stopPropagation();
    }
  }
}
